import styled from "styled-components";

import colors from "app/styles/theme/colors";
import type { OabPartnershipNotice as OabPartnershipNoticeData } from "../hooks/useOabPartnershipModal";

const { gray, green, blue } = colors.designSystem;

const ACCENT_BY_TONE = {
  success: green[500],
  warning: colors.red.senary,
  info: blue[500],
};

const Notice = styled.div<{ $tone: keyof typeof ACCENT_BY_TONE }>`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 28px;
  padding: 14px 16px;
  border: 1px solid ${gray[200]};
  border-left: 3px solid ${({ $tone }) => ACCENT_BY_TONE[$tone]};
  border-radius: 8px;
  background: ${gray[100]};
`;

const Title = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${gray[900]};
`;

const Text = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${gray[700]};
  line-height: 1.45;
`;

type Props = {
  notice?: OabPartnershipNoticeData;
};

const OabPartnershipNotice = ({ notice }: Props) => {
  if (!notice) return null;

  return (
    <Notice $tone={notice.tone} role="status" aria-live="polite">
      <Title>{notice.title}</Title>
      <Text>{notice.text}</Text>
    </Notice>
  );
};

export default OabPartnershipNotice;
